module.exports = __webpack_public_path__ + "static/media/ethlogo.802c6eac.svg";